import React from 'react';
import loadable from '@loadable/component';
import { PopularFacetsFragment } from 'src/types';

type Props = {
  popularFacets: PopularFacetsFragment['popularFacets'];
};
const LoadableComponent = loadable<Props>(() =>
  import(/* webpackChunkName: "popular-facets" */ './popular-facets-sections')
);
const CampaignBannerLoader = (props: Props) => <LoadableComponent {...props} />;

export default CampaignBannerLoader;
